import { Button, Typography, makeStyles, Box } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import FilterIcon from "../atoms/icons/FilterIcon";
import Dropdown from "./Dropdown";
import clsx from "clsx";
import useFetchCnae from "../../customHooks/UseFetchCnae";
import useCnaeContext from "../../contexts/CnaeContext";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "auto",
    borderRadius: "12px",
    background: "#EBECF1",
    padding: "14px",
    border: "1px solid #EBECF1",
    "& .MuiTypography-body1": {
      marginLeft: "10px",
    },
    "&:hover": {
      background: "#e1f3ff",
      border: "1px solid #0093f5",
      "& .MuiTypography-body1": {
        color: "#0093f5",
      },
      "& svg > path": {
        fill: "#0093f5",
      },
    },

    "& .filterIcon > path": {
      background: "black",
    },
  },
  hasFilters: {
    background: theme.palette.primary.soft,
    "& .MuiTypography-body1": {
      color: theme.palette.primary.main,
    },
  },
  howManyFilters: {
    background: theme.palette.primary.main,
    color: "white",
    borderRadius: "100px",
    width: "25px",
    marginLeft: "12px",
  },
}));

export default function Filter({ setLoading, setFilterError }) {
  const classes = useStyles();

  const { valueInput, applyFilter, filters } = useCnaeContext();
  const [menuAnchor, setMenuAnchor] = useState(null);
  const { fetch } = useFetchCnae();

  async function filtersLength(filterParams) {
    setLoading(true);
    const data = await fetch({
      search: valueInput,
      status: filterParams,
    });
    if (data.cnaes.length < 1) {
      setFilterError(true);
    } else {
      applyFilter(data);
      setFilterError(false);
    }
    setLoading(false);
  }

  function getCheckedFiltersLength() {
    const result = Object.keys(filters).filter(
      (check) => filters[check] === true
    );
    return result.length;
  }

  return (
    <>
      <Button
        className={clsx(
          classes.container,
          getCheckedFiltersLength() !== 0 ? classes.hasFilters : ""
        )}
        onClick={(e) => setMenuAnchor(e.currentTarget)}
      >
        <FilterIcon />
        <Typography variant="body1">Filtrar</Typography>
        {getCheckedFiltersLength() > 0 && (
          <Box className={classes.howManyFilters}>
            {getCheckedFiltersLength()}
          </Box>
        )}
      </Button>
      <Dropdown
        filtersLength={filtersLength}
        menuAnchor={menuAnchor}
        setMenuAnchor={setMenuAnchor}
      />
    </>
  );
}

Filter.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setFilterError: PropTypes.func.isRequired,
};
